import { Link } from "react-router-dom";

const ChatRoute = ({ role }) => {
  return (
    <>
      {role === "professional" ? (
        <Link to={"/professional/chat"}>
          <span className="category-box title-box-text me-2">Chat Now</span>
        </Link>
      ) : role === "employee" ? (
        <Link to={"/user/chat"}>
          <span className="category-box title-box-text me-2">Chat Now</span>
        </Link>
      ) : role === "user" ? (
        <Link to={"/user/chat"}>
          <span className="category-box title-box-text me-2">Chat Now</span>
        </Link>
      ) : (
        ""
      )}
    </>
  );
};

export default ChatRoute;
